import { ContentfulProductBanner } from '@jbhi-fi/apis/src/contentful/types';
import { ThemeTransformer } from './ThemeTransformer';
import { ProductBannerProduct, ProductHtmlBannerProps } from '../../ProductHtmlBanner/types';
import { WithProductProviderProps } from '../../context/ProductProvider';
import { buildContentfulApiImgSrc } from '../../ContentfulImage/buildContentfulApiImgSrc';

export abstract class ProductBannerTransformer {
  static toProductHtmlBannerProps = (
    entry: ContentfulProductBanner
  ): WithProductProviderProps<ProductHtmlBannerProps> => {
    return {
      heading: entry.fields.heading,
      url: entry.fields.url,
      overallEndDate: entry.fields.overallEndDate ? new Date(entry.fields.overallEndDate) : undefined,
      headingTheme: entry.fields.theme && ThemeTransformer.toContentThemePalette(entry.fields.theme),
      contentProducts: createProductsArray(entry),
      productVariantIds:
        ([entry.fields.product1?.[0], entry.fields.product2?.[0], entry.fields.product3?.[0]].filter(
          Boolean
        ) as Array<string>) ?? [],
      trackingData: {
        id: entry?.fields?.name ?? '',
        url: entry?.fields?.url,
        type: 'carousel',
      },
      backgroundImageUrl:
        buildContentfulApiImgSrc(entry.fields.theme?.fields?.backgroundImage?.fields.file.url) || undefined,
    };
  };
}

const createProductsArray = (entry: ContentfulProductBanner): Array<ProductBannerProduct> => {
  const MAX_PRODUCTS = 3;
  let index = 1 as 1 | 2 | 3;
  const products: Array<ProductBannerProduct> = [];

  for (index; index <= MAX_PRODUCTS; index++) {
    if (entry.fields?.[`product${index}`]?.[0]) {
      products.push({
        variantId: entry.fields?.[`product${index}`]?.[0] as string,
        endDate: entry.fields[`endDate${index}`] ? new Date(entry.fields[`endDate${index}`]!) : undefined,
        tagType: (entry.fields[`tagType${index}`] as ProductBannerProduct['tagType']) ?? undefined,
        badge: (entry.fields[`badge${index}`] as ProductBannerProduct['badge']) ?? undefined,
        badgeStyle: (entry.fields[`badgeStyle${index}`] as ProductBannerProduct['badgeStyle']) ?? undefined,
        enableEAPriceBox: entry.fields[`isEA${index}`] ?? false,
      });
    }
  }

  return products;
};
